import {Component, OnDestroy, OnInit} from '@angular/core';

import {UserRight, UserRightCategory} from "../../../shared/models/entities/user-right";
import {UserRole, UserRoleType} from "../../../shared/models/entities/user-role";
import {Subscription} from "rxjs";
import {UserService} from "../../../shared/services/api/user.service";
import {Title} from "@angular/platform-browser";
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'laveo-invoices',
  templateUrl: './invoices.component.html',
  styleUrl: './invoices.component.scss'
})
export class InvoicesComponent implements OnInit, OnDestroy {
  selectedIndex = 0;
  private initialized = false;
  category = UserRightCategory.invoiceRequests;

  currentRole?: UserRole;  private subscriptions: Subscription[] = [];
  protected isAllowed: boolean;
  protected isAdmin: boolean;
  protected isStructure: boolean;
  protected isCustomerOrCustomerSite: boolean;

  constructor(
    private readonly userService: UserService,
    private readonly titleService: Title,
    private route: ActivatedRoute,
    private router: Router
  ) {}


  ngOnInit(): void {
    this.setTitle();
    this.loadRole();
    this.route.queryParams.subscribe(params => {
      if (params.tab !== undefined) {
        this.selectedIndex = +params.tab;
      }
      this.initialized = true;
    });
  }

  onTabChange(index: number): void {

    if (this.initialized) {
      void this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {tab: index}
      });
    }
  }
  ngOnDestroy(): void {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }
  goToAdmin(): void {
    void this.router.navigate(['/admin']);
  }


  private loadRole(): void {
    const roleSubscription = this.userService.currentRole.subscribe(role => {
      this.currentRole = role;
      this.isAdmin = role.type === UserRoleType.admin;
      this.isStructure = role.type === UserRoleType.structure;
      this.isCustomerOrCustomerSite = (role.type === UserRoleType.customer || role.type === UserRoleType.customerSite );
      const userCanRead = role.rights.invoiceRequests.includes(UserRight.read);
      const userCanEdit = role.rights.invoiceRequests.includes(UserRight.update);
      const userCanDelete = role.rights.invoiceRequests.includes(UserRight.delete);

      this.isAllowed = this.isAdmin || userCanRead || userCanEdit || userCanDelete;

    });

    if (roleSubscription) {
      this.subscriptions.push(roleSubscription);
    }
  }

  private setTitle(): void {
    this.titleService.setTitle('Lavéo - Gestion des factures');
  }

}
